export const getQueryParamsFromUrl = <T extends Record<string, string | string[]>>(apiUrl: string): T => {
  const url = new URL(apiUrl)
  const searchParams = new URLSearchParams(url.search)

  return Array.from(searchParams.entries()).reduce<T>((queryParams, [key, value]) => {
    if (!queryParams[key]) {
      return { ...queryParams, [key]: value }
    }

    return {
      ...queryParams,
      [key]: Array.isArray(queryParams[key]) ? [...queryParams[key], value] : [queryParams[key] as string, value]
    }
  }, {} as T)
}

export const fileNameFunc = (start: string, end: string) => {
  return `donation_report_start_${start}_end_${end}`
}

export const replaceDashWithEmptySpace = (str: string) => str.replace('-', ' ')

export const inMiddleEllipsis = (str: string): string => {
  if (str.length > 35) {
    return `${str.substr(0, 20)}...${str.substr(str.length - 10, str.length)}`
  }

  return str
}

export const kebabCase = string =>
  string
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase()

export const formatCountryNamesString = countryNames => {
  if (countryNames.length === 1) {
    return countryNames[0]
  }

  if (countryNames.length === 2) {
    return countryNames.join(' and ')
  }

  return `${countryNames.slice(0, -1).join(', ')} and ${countryNames[countryNames.length - 1]}`
}

export const mapCountriesToOptions = (countries, configData) => {
  const filteredCountries =
    configData && configData.length > 0
      ? countries.filter(({ alpha3Code }) => configData.includes(alpha3Code))
      : countries

  return filteredCountries.map(({ alpha3Code, countryName }) => ({
    value: alpha3Code,
    label: countryName
  }))
}

const downloadBlob = (blob: Blob, baseFileName: string, extension: string): void => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${baseFileName}.${extension}`)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

export const downloadCsvFile = (data: Blob | string, baseFileName: string): void =>
  downloadBlob(data instanceof Blob ? data : new Blob([data], { type: 'text/csv' }), baseFileName, 'csv')

export const downloadJsonFile = (data: unknown, baseFileName: string): void =>
  downloadBlob(new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' }), baseFileName, 'json')
